module.exports = __webpack_public_path__ + "assets/b387966e581c27a885a6dac8e48c871f.mp3";